import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { Treatment } from 'app/core/classes/treatment';

@Component({
  selector: 'app-treatment-fields',
  templateUrl: './aus_preTravel_treatment_fields.component.html',
  styleUrls: ['./aus_preTravel_treatment_fields.component.less']
})
export class AusPreTravelTreatmentFields implements OnChanges {
  @Input() treatment: Treatment;
  @Input() selectedTab: string = "";
  @Input() hasNoTreatment: boolean;
  @Input() toggleLabel: string;
  @Input() disabledFields: boolean;
  @Input() showOtherSubstancesInput: boolean;
  @Input() treatmentForm: any;
  @Output() setHasNoTreatment = new EventEmitter<boolean>();
  @Output() onOtherSubstanceChange = new EventEmitter<boolean>();

  ngOnChanges(changes: SimpleChanges) {
    if (!!this.treatment.other_substances) {
      this.showOtherSubstancesInput = !!this.treatment.other_substances
    }
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/common/aus-treatment-fields/aus_preTravel_treatment_fields.component.ts